import React, { Component, Fragment } from 'react'
import SearchFilter from '../../../../Templates/SearchFilter'
import { imageAttachments, videoAttachments, audioAttachments, pdfAttachments, modelAttachments, viewAttachmentIcon, attachFileIcon, removeFileIcon, hamburger, uploadIcon, AtoZ , PickColorTextureIcon} from '../../../../Templates/icons'
import { SORT, renderTypeIcon, getRegexSelection } from "../../../../Templates/functions"
import { imageExtensions, audioExtensions, videoExtensions, documentExtensions, modelExtensions} from "../../../../Templates/data"
import FilePreview from './Preview/FilePreview'
import CircularProgress from '@material-ui/core/CircularProgress';
import axios from 'axios'
import AtoZAsc from '../../../../../assets/Icons/A-Z_1.png'
import AtoZDesc from '../../../../../assets/Icons/A-Z_2.png'
import AtoZGrayed from '../../../../../assets/Icons/A-Z-Grayed-PH.png'
import uploadFileIcon from '../../../../../assets/Icons/upload_file_icon.png'
import attachFileIconPng from '../../../../../assets/Icons/attach_file_icon.png'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import {createAttachmentInUse, deleteAttachmentInUse } from '../../../../../util/wi_util'
import { checkIfAttachmentExists } from '../../../../../util/attachment_util'
import { triggerShowLoader, triggerHideLoader } from '../../../../../LoadingContext';

// Import texture images - using renamed files without spaces
import rubberTexture from '../../../../../assets/textures/rubber1_seamless.png'
import rubber2Texture from '../../../../../assets/textures/rubber2_seamless.png'
import rubber3Texture from '../../../../../assets/textures/rubber3_seamless.png'
import rubber4Texture from '../../../../../assets/textures/rubber4_seamless.png'

// Metal textures with new names
import steelTexture from '../../../../../assets/textures/22_polished_stainless_steel_seamless.jpg'
import polishedSteelTexture from '../../../../../assets/textures/5_polished_stainless_steel_seamless.jpg'
import ironTexture from '../../../../../assets/textures/25_iron_metal_seamless.jpg'
import iron2Texture from '../../../../../assets/textures/69_iron_metal_seamless.jpg'
import copperTexture from '../../../../../assets/textures/32_copper_metal_seamless.jpg'
import copper2Texture from '../../../../../assets/textures/59_copper_metal_seamless.jpg'
import bronzeTexture from '../../../../../assets/textures/45_bronze_satin_metal_seamless.jpg'
import darkBronzeTexture from '../../../../../assets/textures/68_brushed_dark_bronze_seamless.jpg'
import brassTexture from '../../../../../assets/textures/46_brass_metal_seamless.jpg'
import aluminumTexture from '../../../../../assets/textures/66_aluminium_metal_surface_seamless.jpg'
import silverTexture from '../../../../../assets/textures/75_brushed_silver_metal_seamless.jpg'
import metalSurfaceTexture from '../../../../../assets/textures/65_metal_surface_seamless.jpg'
import galvanizedSteel1Texture from '../../../../../assets/textures/76_galvanized_steel_metal_seamless.jpg'
import galvanizedSteel2Texture from '../../../../../assets/textures/77_galvanized_steel_metal_seamless.jpg'
import scratchMetal1Texture from '../../../../../assets/textures/74_scratch_metal_seamless.jpg'
import scratchMetal2Texture from '../../../../../assets/textures/17_scratch_metal_seamless.jpg'
import zinc1Texture from '../../../../../assets/textures/73_zinc_metal_seamless.jpg'
import zinc2Texture from '../../../../../assets/textures/72_zinc_metal_seamless.jpg'
import zinc3Texture from '../../../../../assets/textures/71_zinc_metal_seamless.jpg'
import zinc4Texture from '../../../../../assets/textures/70_zinc_metal_seamless.jpg'

// Debug: Log texture imports to check if they're loading correctly
console.log('Texture imports:', {
    rubberTexture,
    rubber2Texture,
    ironTexture,
    copperTexture,
    steelTexture,
    bronzeTexture
});

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};


const getItemStyle = (isDragging, draggableStyle) => ({
    // basic styles to make the items look a bit nicer
    background: isDragging ? 'lightgreen' : "white",
    userSelect: 'none',
    padding: '8px',
    margin: '0 auto 8px auto',
    width: '80%',           // Reduced from 100%
    maxWidth: '400px',      // Added maximum width
    minWidth: '120px',      // Added minimum width
    
    // styles we need to apply on draggables
    ...draggableStyle,
});

const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? 'lightblue' : '#dde1e2',
    marginTop: '.5em'
});

export default class AttachmentsLibrary extends Component {
    signal = axios.CancelToken.source()
    // Add texture data - all textures with renamed files
    textures = [
        // Row 1 - Steel variants
        { id: 1, name: 'Steel', file: '22_polished_stainless_steel_seamless.jpg', path: steelTexture },
        { id: 2, name: 'Polished Steel', file: '5_polished_stainless_steel_seamless.jpg', path: polishedSteelTexture },
        { id: 3, name: 'Galvanized Steel', file: '76_galvanized_steel_metal_seamless.jpg', path: galvanizedSteel1Texture },
        
        // Row 2 - More Steel & Iron
        { id: 4, name: 'Galvanized Steel 2', file: '77_galvanized_steel_metal_seamless.jpg', path: galvanizedSteel2Texture },
        { id: 5, name: 'Iron', file: '25_iron_metal_seamless.jpg', path: ironTexture },
        { id: 6, name: 'Iron 2', file: '69_iron_metal_seamless.jpg', path: iron2Texture },
        
        // Row 3 - Scratch Metals
        { id: 7, name: 'Scratch Metal', file: '74_scratch_metal_seamless.jpg', path: scratchMetal1Texture },
        { id: 8, name: 'Scratch Metal 2', file: '17_scratch_metal_seamless.jpg', path: scratchMetal2Texture },
        { id: 9, name: 'Metal Surface', file: '65_metal_surface_seamless.jpg', path: metalSurfaceTexture },
        
        // Row 4 - Copper & Bronze
        { id: 10, name: 'Copper', file: '32_copper_metal_seamless.jpg', path: copperTexture },
        { id: 11, name: 'Copper 2', file: '59_copper_metal_seamless.jpg', path: copper2Texture },
        { id: 12, name: 'Bronze', file: '45_bronze_satin_metal_seamless.jpg', path: bronzeTexture },
        
        // Row 5 - More Bronze & Other Metals
        { id: 13, name: 'Dark Bronze', file: '68_brushed_dark_bronze_seamless.jpg', path: darkBronzeTexture },
        { id: 14, name: 'Brass', file: '46_brass_metal_seamless.jpg', path: brassTexture },
        { id: 15, name: 'Silver', file: '75_brushed_silver_metal_seamless.jpg', path: silverTexture },
        
        // Row 6 - Aluminum & Zinc
        { id: 16, name: 'Aluminum', file: '66_aluminium_metal_surface_seamless.jpg', path: aluminumTexture },
        { id: 17, name: 'Zinc', file: '73_zinc_metal_seamless.jpg', path: zinc1Texture },
        { id: 18, name: 'Zinc 2', file: '72_zinc_metal_seamless.jpg', path: zinc2Texture },
        
        // Row 7 - More Zinc
        { id: 19, name: 'Zinc 3', file: '71_zinc_metal_seamless.jpg', path: zinc3Texture },
        { id: 20, name: 'Zinc 4', file: '70_zinc_metal_seamless.jpg', path: zinc4Texture },
        { id: 21, name: 'Rubber', file: 'rubber1_seamless.png', path: rubberTexture },
        
        // Row 8 - Rubber variants
        { id: 22, name: 'Rubber 2', file: 'rubber2_seamless.png', path: rubber2Texture },
        { id: 23, name: 'Rubber 3', file: 'rubber3_seamless.png', path: rubber3Texture },
        { id: 24, name: 'Rubber 4', file: 'rubber4_seamless.png', path: rubber4Texture }
    ];

    state = {
        isLoading: true,
        searchText: "",
        selectedCurrentAttachment: null,
        selectedLibraryItem: null,
        filteredCurrentAttachments: [],
        filteredAllAttachments: [],
        filteringAttachments: false,
        extensionFilter: false,
        sortOrder: 'grayed',
        currentAttachments: this.props.isAll ? [] :  Object.values(this.props.currentAttachments),
        remainingAttachments: this.props.isAll ? [] : Object.values(this.props.currentAttachments),
        selectedTextureIndex: null,
        texturesSaved: false,
        contextMenu: {
            show: false,
            x: 0,
            y: 0,
            attachment: null
        }
    }

    componentDidMount = () => {
        // console.log("seeing what we are sending the library")
        // console.log(this.props)
        this.loadData()
        setTimeout(() => {
            if (typeof this.props.libraryOpen === 'function') {
                this.props.libraryOpen();
            }
        }, 0);
    }

    componentWillUnmount = () => {
        this.signal.cancel('Api is being canceled');
        
        // If textures were saved during this session, notify parent to refresh data
        if (this.state.texturesSaved && this.props.onTexturesSaved) {
            this.props.onTexturesSaved();
        }

        // Remove global click listener for context menu
        document.removeEventListener('click', this.hideContextMenu);
    }

    // Context menu handlers
    showContextMenu = (e, attachment) => {
        e.preventDefault();
        e.stopPropagation();
        
        this.setState({
            contextMenu: {
                show: true,
                x: e.clientX,
                y: e.clientY,
                attachment: attachment
            }
        });

        // Add global click listener to hide context menu
        document.addEventListener('click', this.hideContextMenu);
    }

    hideContextMenu = () => {
        this.setState({
            contextMenu: {
                show: false,
                x: 0,
                y: 0,
                attachment: null
            }
        });
        document.removeEventListener('click', this.hideContextMenu);
    }

    deleteAttachment = () => {
        const attachment = this.state.contextMenu.attachment;
        if (!attachment) return;

        // Confirm deletion
        if (window.confirm(`Are you sure you want to delete "${attachment.path}"? This will hide it from the library but keep it in any Work Instructions where it's currently used.`)) {
            // Call the API to soft delete the attachment
            this.props.softDeleteAttachment(attachment._id)
                .then(() => {
                    // Remove from remaining attachments immediately
                    const updatedRemainingAttachments = this.state.remainingAttachments.filter(
                        att => att._id !== attachment._id
                    );

                    this.setState({
                        remainingAttachments: updatedRemainingAttachments
                    });

                    console.log(`Attachment "${attachment.path}" has been soft deleted from library`);
                })
                .catch((error) => {
                    console.error('Error deleting attachment:', error);
                    window.alert('Failed to delete attachment. Please try again.');
                });
        }

        this.hideContextMenu();
    }

    loadData = () => {
        let signalToken = this.signal.token;
        // Only fetch attachments
        this.props.fetchAllAttachments(signalToken)
            .then(res => {
                let attachments = res.attachments || []; // Ensure array

                // Process attachments to ensure consistent structure (path, fileExtension)
                const allProcessedAttachments = attachments.map(attachment => {
                    const processedAtt = { ...attachment }; // Clone attachment
                    
                    // Standardize file extension property
                    processedAtt.fileExtension = processedAtt.fileExtension || processedAtt.file_extension;
                    if (!processedAtt.fileExtension && processedAtt.path) {
                        const parts = processedAtt.path.split('.');
                        if (parts.length > 1) {
                            processedAtt.fileExtension = parts.pop();
                        }
                    }
                    // Ensure path exists
                    processedAtt.path = processedAtt.path || '';

                    // Remove temp_model_id if you don't need it downstream
                    // delete processedAtt.temp_model_id;

                    return processedAtt;
                });

                // console.log('All Processed Attachments:', JSON.stringify(allProcessedAttachments)); // DEBUG

                // Filter based on current attachments props
                let remainingAttachments = allProcessedAttachments.filter((item) => {
                    return !(
                        this.props.currentAttachments &&
                        this.props.currentAttachments[item._id]
                    );
                });

                // console.log('Calculated Remaining Attachments (Attachments Only):', JSON.stringify(remainingAttachments)); // DEBUG
                // console.log('Props Current Attachments (during loadData):', JSON.stringify(this.props.currentAttachments)); // DEBUG

                this.setState({
                    isLoading: false,
                    remainingAttachments,
                });
            })
            .catch((err) => {
                if (axios.isCancel(err)) {
                    console.info('Attachment Library loadData cancelled:', err.message);
                } else {
                    console.error('Error loading attachment data:', err);
                    this.setState({
                        isLoading: false,
                        isError: err.message || 'Failed to load attachments',
                        remainingAttachments: [],
                    });
                }
            });
    };

    /**
     * A semi-generic way to handle multiple lists. Matches
     * the IDs of the droppable container to the names of the
     * source arrays stored in the state.
     */
    id2List = {
        droppable: 'currentAttachments',
        droppable2: 'remainingAttachments'
    };

    getList = id => this.state[this.id2List[id]];

    // Function to toggle the sort order
    toggleSortOrder = () => {
        this.setState((prevState) => ({
        sortOrder:
            prevState.sortOrder === 'ascending'
            ? 'descending'
            : prevState.sortOrder === 'descending'
            ? 'ascending'
            : 'ascending',
        extensionFilter: 'AtoZ', // Set extensionFilter to 'AtoZ'
        }));
    };

    // Function to get the appropriate sorting icon based on sortOrder
    getSortingIcon = () => {
        const { sortOrder } = this.state;
        const iconStyle = { width: '70px', height: '55px', marginLeft: '25px' }; // Inline styling for the image
    
        if (sortOrder === 'ascending') {
        return <img src={AtoZAsc} alt="Ascending" onClick={this.toggleSortOrder} style={iconStyle} />;
        } else if (sortOrder === 'descending') {
        return <img src={AtoZDesc} alt="Descending" onClick={this.toggleSortOrder} style={iconStyle} />;
        } else {
        return <img src={AtoZGrayed} alt="Grayed" style={iconStyle} onClick={this.toggleSortOrder}/>;
        }
    };

    onDragEnd = result => {
        //source is the originating list
        //destination is the list you are dropping into
        const { source, destination } = result;
        // dropped outside the list do nothing
        if (!destination) {
            return;
        }

        //if dropping into same list reorder the contents of that list (at provide indices)
        if (source.droppableId === destination.droppableId) {
            const reorderedList = reorder(
                this.getList(source.droppableId),
                source.index,
                destination.index
            );
            
            //determine which list was being dragged over and sets reorder list into state
            let state = source.droppableId === 'droppable2' ? { remainingAttachments: reorderedList } : { currentAttachments: reorderedList };
            if (this.props.isPDFViewer){
                
                this.props.saveNewPDFHighLightAttachments(reorderedList)
            }
            else{
                let selectedStep = this.props.selectedStep
                selectedStep.attachments = reorderedList
                for(let i = 0;i < selectedStep.attachments.length;i++){
                    selectedStep.attachments[i].order = i
                }
                let steps = this.props.updateStep(selectedStep)
                this.setState(state,()=>{ this.props.updateSteps(steps, selectedStep)})
            }
        }
    };
    
    attachFile = (file) => {
        // No loader trigger here, uploadMediaFile handles the start
        file.WIPID = this.props.WIPID
        file.HighlightID = this.props.HighlightID
        file.StepID = this.props.selectedStep._id
        file.order = this.props.selectedStep.attachments.length
        createAttachmentInUse(file).then((attachment)=>{
            attachment.HighlightID = this.props.HighlightID
            let att = JSON.parse(attachment.config.data)
            att.highlightID = this.props.HighlightID
            att.inUseID = attachment.data.inUseID
            if (this.props.isPDFViewer){
                let attachmentClone = this.props.currentlySelectedPDFAnnotationAttachment.filter(ra => ra !== att )
                attachmentClone.push(att)
                this.props.saveNewPDFHighLightAttachments(attachmentClone)
                let currentAttachments = this.state.currentAttachments
                let remainingAttachments = this.state.remainingAttachments.filter(remainingAttachment => remainingAttachment !== att)
    
                currentAttachments.push(att)
                this.props.saveNewPDFHighLightAttachments(currentAttachments)
                this.setState({ currentAttachments, remainingAttachments }, () => {
                    triggerHideLoader(); // Hide loader after state update
                })
            }
            else{
                let selectedStep = this.props.selectedStep
                let currentAttachments = this.state.currentAttachments
                let remainingAttachments = this.state.remainingAttachments.filter(remainingAttachment => remainingAttachment !== att)
                currentAttachments.push(att)
                
                selectedStep.attachments = currentAttachments;
                let steps = this.props.updateStep(selectedStep)
                this.setState({ currentAttachments, remainingAttachments }, ()=>{
                    this.props.updateSteps(steps, selectedStep)
                    triggerHideLoader(); // Hide loader after state update
                    
                })
            }
        }).catch((error)=>{
            console.log(error)
            triggerHideLoader(); // Hide loader on error
        })

    }

    removeAnnotationsForDetachedAttachment = (step, removedIndex) => {
        if (!step || removedIndex == null || removedIndex < 0) {
            return;
        }

        let content = step.content || "";
        if (!content) {
            return;
        }

        const matches = getRegexSelection(content, new RegExp('\\&lt;Annotation,(.*?),(.*?),(.*?).&gt;', 'g'));
        if (!matches || matches.length === 0) {
            return;
        }

        matches.forEach(match => {
            const attachmentIndex = parseInt(match[2], 10);
            if (!Number.isNaN(attachmentIndex) && attachmentIndex === removedIndex) {
                content = content.replace(match[0], match[3]);
            }
        });

        step.content = content;
    }

    shiftAnnotationIndicesAfterDetach = (step, removedIndex) => {
        if (!step || removedIndex == null || removedIndex < 0) {
            return;
        }

        let content = step.content || "";
        if (!content) {
            return;
        }

        const regex = new RegExp('\\&lt;Annotation,(.*?),(.*?),(.*?).&gt;', 'g');
        let didUpdate = false;

        content = content.replace(regex, (match, annoId, attachmentIdx, displayText) => {
            const parsedIndex = parseInt(attachmentIdx, 10);
            if (!Number.isNaN(parsedIndex) && parsedIndex > removedIndex) {
                didUpdate = true;
                const newIndex = parsedIndex - 1;
                return `&lt;Annotation,${annoId},${newIndex},${displayText}.&gt;`;
            }
            return match;
        });

        if (didUpdate) {
            step.content = content;
        }
    }

    detachFile = (attachment) => {
        triggerShowLoader(); // Show loader at the start of detach
        deleteAttachmentInUse(attachment).then((data)=>{
            if (this.props.isPDFViewer){
                let attachmentClone = this.props.currentlySelectedPDFAnnotationAttachment.filter(ra => ra !== attachment )
                
                let currentAttachments = this.state.currentAttachments.filter(currentAttachment => currentAttachment !== attachment)
                this.props.saveNewPDFHighLightAttachments(currentAttachments)
                this.setState({ currentAttachments, selectedCurrentAttachment: null }, () => {
                    triggerHideLoader(); // Hide loader after state update
                })
            }
            else{
                let selectedStep = this.props.selectedStep
                const removedAttachmentIndex = this.state.currentAttachments.findIndex(currentAttachment => currentAttachment === attachment)
                this.removeAnnotationsForDetachedAttachment(selectedStep, removedAttachmentIndex)
                this.shiftAnnotationIndicesAfterDetach(selectedStep, removedAttachmentIndex)

                let currentAttachments = this.state.currentAttachments.filter(currentAttachment => currentAttachment !== attachment)
                for (let i = 0; i < currentAttachments.length; i++){
                    currentAttachments[i].order = i
                }
                let remainingAttachments = this.state.remainingAttachments
                remainingAttachments.push(attachment)
                selectedStep.attachments = currentAttachments
                let steps = this.props.updateStep(selectedStep)
                this.setState({ currentAttachments, remainingAttachments, selectedCurrentAttachment: null }, ()=>{ 
                    this.props.updateSteps(steps, selectedStep, false, false, undefined, false, true)
                    triggerHideLoader(); // Hide loader after state update
                })
            }
        }).catch((error)=>{
            console.log(error)
            triggerHideLoader(); // Hide loader on error
        })
    }

    filterLists = (searchText) => {
        if (searchText === "") {
            this.setState(prevState => ({
                filteringAttachments: false,
                searchText: ""
            }))
        } else {
            this.setState(prevState => ({
                filteringAttachments: true,
                searchText
            }))
        }
    }

    uploadFile = () => {
        let input = document.getElementById("attachment")
        input.click()
    }

    uploadMediaFile = (e) => {
        e.preventDefault()
        const attachment = e.target.files[0]
        // let viewWindow = document.getElementById('wi-author-page') // Removed wait class logic
        // viewWindow.classList.add("wait"); 
        console.log("Uploading media file...") // Changed log message slightly
        checkIfAttachmentExists(e.target.files[0].name).then((attach)=>{
            if(attach.data === true){
                window.alert("Attachment already exists")
                return
            }else{
                if (!this.props.isAll && Object.values(this.props.currentAttachments).some(attachment => attachment.path === attachment.name)) {
                    window.alert("Attachment filenames should be unique")
                    // viewWindow.classList.remove("wait") // Removed wait class logic
                } 
                else {
                    try{
                    //const attachment = e.target.files[0]
                    const fd = new FormData();
                    let path = attachment.name
                    // Handle spaces by replacing them with underscores
                    if (path.indexOf(' ') >= 0) {
                        const originalName = path;
                        path = path.replace(/\s+/g, '_');
                        console.log(`File name with spaces detected. Renamed from "${originalName}" to "${path}"`);
                    }
                    let regex = new RegExp(/.(png|PNG|tiff|TIFF|jpg|JPG|jpeg|JPEG|mp4|MP4|MOV|mov|mp3|MP3|pdf|PDF|obj|OBJ|fbx|FBX|glb|GLB)$/)
                    let match = path.match(regex)
                    let fileExtension = match ? match[0].slice(1) : null
                    if (fileExtension && fileExtension.includes(".")){
                        fileExtension = fileExtension.slice(1)
                    }

                    if(fileExtension) {
                        triggerShowLoader(); // Show loader before starting upload
                        fd.append('attachment', attachment)
                        fd.append('path', path)
                        // setTimeout(() => { // Removed automatic removal timeout
                        //     viewWindow.classList.remove("wait"); 
                        // }, 5000); 
                        Promise.all([this.props.uploadFile(fd)]).then(([res]) => {
                            let payload = { _id: res._id, fileExtension, path }
                            if(!this.props.isAll){                   
                                this.attachFile(res) // attachFile will handle hiding the loader on success
                            }
                            else{
                                this.loadData();
                                triggerHideLoader(); 

                            }
                        }).catch(err => {
                            console.log(err)
                            window.alert("An Error occured in uploading that file.", err)
                            // viewWindow.classList.remove("wait") // Removed wait class logic
                            triggerHideLoader(); // Hide loader on upload error
                        })
                    } else {
                        // viewWindow.classList.remove("wait") // Removed wait class logic
                        return window.alert("You are attempting to upload an attachment type that is not supported. Supported attachment extensions are .png, .tiff, .jpg, .jpeg, .mp4, .mov, .mp3, and .pdf.")
                    }
                }catch(e){
                    console.log(e)
                    alert("There was an error uploading the selected file.")
                }
                }
                        
        }
})
    }

    previewAttachment = () => {
        this.setState( prevState => {
            return {
                previewingAttachment: this.state.selectedCurrentAttachment || this.state.selectedLibraryItem
            }})
    }

    pickColorTexture = () => {
        this.setState( prevState => {
            return {
                pickingColorTexture: this.state.selectedCurrentAttachment || this.state.selectedLibraryItem
            }})
    }

    handleTextureSelect = (textureIndex) => {
        this.setState({ selectedTextureIndex: textureIndex });
        // The ColorTexturePickerPreview component will handle applying the texture
        // through componentDidUpdate when selectedTextureIndex changes
    }

    handleResetToOriginal = () => {
        this.setState({ selectedTextureIndex: 'reset' });
        // The ColorTexturePickerPreview component will handle the reset
    }

    clearTextureSelection = () => {
        this.setState({ selectedTextureIndex: null });
    }

    handleTexturesSaved = async () => {
        console.log('[AttachmentsLibrary] Textures saved, refetching attachment data...');
        
        // Refetch the attachment data to get the updated texture_config
        const attachmentId = this.state.pickingColorTexture?.temp_model_id || this.state.pickingColorTexture?._id;
        
        if (attachmentId) {
            try {
                const response = await axios.get(
                    `${window.config.getApiBaseUrl()}/api/attachments/${attachmentId}/texture-config`,
                    {
                        headers: {
                            'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
                        }
                    }
                );
                
                if (response.data && response.data.textureConfig !== undefined) {
                    console.log('[AttachmentsLibrary] Got updated texture config:', response.data.textureConfig);
                    
                    // Helper function to update attachment with new texture_config
                    const updateAttachment = (att) => {
                        if (att && (att._id === attachmentId || att.temp_model_id === attachmentId)) {
                            return { ...att, texture_config: response.data.textureConfig };
                        }
                        return att;
                    };
                    
                    // Update ALL state properties that might contain this attachment
                    this.setState(prevState => {
                        const updatedCurrentAttachments = prevState.currentAttachments.map(updateAttachment);
                        const updatedRemainingAttachments = prevState.remainingAttachments.map(updateAttachment);
                        
                        return {
                            pickingColorTexture: updateAttachment(prevState.pickingColorTexture),
                            selectedCurrentAttachment: updateAttachment(prevState.selectedCurrentAttachment),
                            selectedLibraryItem: updateAttachment(prevState.selectedLibraryItem),
                            previewingAttachment: updateAttachment(prevState.previewingAttachment),
                            currentAttachments: updatedCurrentAttachments,
                            remainingAttachments: updatedRemainingAttachments,
                            texturesSaved: true
                        };
                    });
                }
            } catch (error) {
                console.error('[AttachmentsLibrary] Error fetching updated texture config:', error);
            }
        }
        
        this.setState({ texturesSaved: true });
    }

    renderTextureSelector = () => {
        return (
            <div style={{
                padding: '20px',
                backgroundColor: '#f8f9fa',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }}>
                <h4 style={{ 
                    margin: '0 0 20px 0', 
                    fontSize: '16px', 
                    color: '#081F5F',
                    textAlign: 'center'
                }}>
                    Select Texture
                </h4>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, 50px)',
                    gap: '8px',
                    justifyContent: 'center',
                    flex: '1',
                    // overflowY: 'auto',
                    padding: '10px',
                    alignContent: 'start'
                }}>
                    {/* Reset to Original Circle */}
                    <div
                        onClick={this.handleResetToOriginal}
                        style={{
                            width: '50px',
                            height: '50px',
                            borderRadius: '50%',
                            border: this.state.selectedTextureIndex === 'reset' ? '3px solid #081F5F' : '2px solid #ccc',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                            transition: 'all 0.2s ease',
                            position: 'relative',
                            overflow: 'hidden',
                            background: 'linear-gradient(45deg, #f0f0f0 25%, transparent 25%), linear-gradient(-45deg, #f0f0f0 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #f0f0f0 75%), linear-gradient(-45deg, transparent 75%, #f0f0f0 75%)',
                            backgroundSize: '8px 8px',
                            backgroundPosition: '0 0, 0 4px, 4px -4px, -4px 0px'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.transform = 'scale(1.1)';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.transform = 'scale(1)';
                        }}
                        title="Reset to Original"
                    >
                        <span style={{
                            color: '#081F5F',
                            fontSize: '20px',
                            fontWeight: 'bold',
                            textShadow: '1px 1px 2px rgba(255,255,255,0.8)'
                        }}>
                            ↺
                        </span>
                    </div>
                    
                    {this.textures.map((texture, index) => (
                        <div
                            key={texture.id}
                            onClick={() => this.handleTextureSelect(index)}
                            style={{
                                width: '50px',
                                height: '50px',
                                borderRadius: '50%',
                                border: this.state.selectedTextureIndex === index ? '3px solid #081F5F' : '2px solid #ccc',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                                transition: 'all 0.2s ease',
                                position: 'relative',
                                overflow: 'hidden',
                                backgroundImage: `url(${texture.path})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                                backgroundColor: '#f0f0f0' // Fallback color if image doesn't load
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'scale(1.1)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'scale(1)';
                            }}
                            title={`${texture.name} - ${texture.path ? 'Loaded' : 'Not Loaded'}`} // Debug info in tooltip
                            onError={(e) => {
                                console.error(`Failed to load texture: ${texture.name}`, texture.path);
                            }}
                        >
                            <span style={{
                                color: 'white',
                                fontSize: '8px',
                                fontWeight: 'bold',
                                textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
                                textAlign: 'center',
                                backgroundColor: 'rgba(0,0,0,0.6)',
                                padding: '1px 3px',
                                borderRadius: '6px',
                                maxWidth: '45px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }}>
                                {texture.name}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    selectCurrentAttachment = (e, attachment) => {
        if (this.state.selectedCurrentAttachment === attachment) {
            this.setState({ selectedCurrentAttachment: undefined })
        } else {
            this.setState({ selectedCurrentAttachment: attachment, selectedLibraryItem: undefined })
        }
    }

    selectLibraryItem = (e, attachment) => {        
        if (this.state.selectedLibraryItem === attachment) {
            this.setState({ selectedLibraryItem: undefined})
        } else {
            this.setState({ selectedLibraryItem: attachment, selectedCurrentAttachment: undefined })
        }
    }

    toggleAttachment = () => {
        let currentSelection = this.state.selectedCurrentAttachment
        if (currentSelection) {
            this.detachFile(currentSelection)
        } else if (this.state.selectedLibraryItem) {
            this.setState({selectedCurrentAttachment: this.state.selectedLibraryItem, 
                           selectedLibraryItem: ""}, 
                this.attachFile(this.state.selectedLibraryItem))
        }
        return
    }


    toggleFilterIcon = (fileExtensions) => {
        if (this.state.extensionFilter === fileExtensions) {
          // If the same filter is clicked again, reset both filter and sortOrder
          this.setState({
            extensionFilter: false,
            sortOrder: 'grayed',
          });
        } else {
          // If a new filter is clicked, set the filter and reset sortOrder
          this.setState({
            extensionFilter: fileExtensions,
            sortOrder: 'grayed',
          });
        }
    };

    renderLoadingAnimation = () => {
       return !this.state.isError ? 
        <div className="flex-centered" style={{ height: "40em" }}>
            <CircularProgress />
        </div> 
        : 
        <div>An Error Has Occured - {this.state.isError}</div>
    }

    renderActionIcons = () => {
        const sortingIcon = this.getSortingIcon();
        
        return this.state.previewingAttachment ?
            <Fragment>
                <i className="fas fa-arrow-circle-left clickable attachment-button"
                    onClick={() => this.setState({ previewingAttachment: null })}>Back</i>
                <p className="legend" style={{ alignSelf: "center" }}>{`Previewing: ${this.state.previewingAttachment.path}`}</p>
            </Fragment>
            : this.state.pickingColorTexture ?
            <Fragment>
                <i className="fas fa-arrow-circle-left clickable attachment-button"
                    onClick={() => this.setState({ pickingColorTexture: null })}>Back</i>
                <p className="legend" style={{ alignSelf: "center" }}>{`Pick Color/Texture: ${this.state.pickingColorTexture.path}`}</p>
            </Fragment>
            :
            <Fragment>
                <SearchFilter style={{ border: "2px solid grey", width: "36%" }} filterList={this.filterLists} placeholder="Search By File Name..." />
                {/* {totalAttachments(total, () => this.setState({extensionFilter: false}))} */}
                <div id="attachment-library-filters" className="flex-centered">
                    <svg className="clickable" onClick={() => this.setState({ extensionFilter: null })} width="104" height="31" viewBox="0 0 104 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.5" y="-0.5" width="103" height="29" rx="4.5" transform="matrix(1 0 0 -1 0 29.2969)" stroke="#081F5F" />
                        <path d="M19.374 16.3623C19.4128 17.054 19.576 17.6157 19.8638 18.0474C20.4116 18.8553 21.3773 19.2593 22.7607 19.2593C23.3805 19.2593 23.945 19.1707 24.4541 18.9937C25.4391 18.6506 25.9316 18.0363 25.9316 17.1509C25.9316 16.4868 25.7241 16.0137 25.3091 15.7314C24.8885 15.4548 24.23 15.214 23.3335 15.0093L21.6816 14.6357C20.6025 14.3923 19.8389 14.1239 19.3906 13.8306C18.6159 13.3215 18.2285 12.5605 18.2285 11.5479C18.2285 10.4521 18.6076 9.5529 19.3657 8.8501C20.1239 8.1473 21.1974 7.7959 22.5864 7.7959C23.8647 7.7959 24.9494 8.10579 25.8403 8.72559C26.7368 9.33984 27.1851 10.3249 27.1851 11.6807H25.6328C25.5498 11.0277 25.3727 10.5269 25.1016 10.1782C24.598 9.54183 23.743 9.22363 22.5366 9.22363C21.5627 9.22363 20.8626 9.42839 20.4365 9.83789C20.0104 10.2474 19.7974 10.7233 19.7974 11.2656C19.7974 11.8633 20.0464 12.3005 20.5444 12.5771C20.8709 12.7542 21.6097 12.9756 22.7607 13.2412L24.4707 13.6313C25.2952 13.8195 25.9316 14.0768 26.3799 14.4033C27.1546 14.9733 27.542 15.8006 27.542 16.8853C27.542 18.2355 27.0495 19.2012 26.0645 19.7822C25.085 20.3633 23.945 20.6538 22.6445 20.6538C21.1283 20.6538 19.9412 20.2664 19.0835 19.4917C18.2257 18.7225 17.8052 17.6794 17.8218 16.3623H19.374ZM29.4346 8.06152H30.9287V12.6104C31.2829 12.1621 31.6011 11.8467 31.8833 11.6641C32.3647 11.3486 32.9652 11.1909 33.6846 11.1909C34.974 11.1909 35.8483 11.6419 36.3076 12.5439C36.5566 13.0365 36.6812 13.7199 36.6812 14.5942V20.2969H35.1455V14.6938C35.1455 14.0409 35.0625 13.5622 34.8965 13.2578C34.6253 12.7708 34.1162 12.5273 33.3691 12.5273C32.7493 12.5273 32.1877 12.7404 31.6841 13.1665C31.1805 13.5926 30.9287 14.3978 30.9287 15.582V20.2969H29.4346V8.06152ZM42.4253 19.334C43.4159 19.334 44.0938 18.9604 44.459 18.2134C44.8298 17.4608 45.0151 16.6252 45.0151 15.7065C45.0151 14.8765 44.8823 14.2013 44.6167 13.6812C44.1961 12.8621 43.4712 12.4526 42.4419 12.4526C41.5288 12.4526 40.8647 12.8013 40.4497 13.4985C40.0347 14.1958 39.8271 15.0369 39.8271 16.022C39.8271 16.9683 40.0347 17.7568 40.4497 18.3877C40.8647 19.0186 41.5233 19.334 42.4253 19.334ZM42.4834 11.1494C43.6289 11.1494 44.5973 11.5312 45.3887 12.2949C46.18 13.0586 46.5757 14.182 46.5757 15.665C46.5757 17.0983 46.2271 18.2826 45.5298 19.2178C44.8325 20.153 43.7507 20.6206 42.2842 20.6206C41.0612 20.6206 40.09 20.2083 39.3706 19.3838C38.6512 18.5537 38.2915 17.4414 38.2915 16.0469C38.2915 14.5527 38.6706 13.363 39.4287 12.4775C40.1868 11.5921 41.2051 11.1494 42.4834 11.1494ZM49.0493 11.4067L50.7593 18.4126L52.4941 11.4067H54.1709L55.9141 18.3711L57.7319 11.4067H59.2261L56.6445 20.2969H55.0923L53.2827 13.4155L51.5312 20.2969H49.979L47.4141 11.4067H49.0493ZM70.9053 15.2998L69.0542 9.9126L67.0869 15.2998H70.9053ZM68.1909 8.10303H70.0586L74.4829 20.2969H72.6733L71.4365 16.6445H66.6138L65.2939 20.2969H63.6006L68.1909 8.10303ZM75.8276 8.10303H77.3218V20.2969H75.8276V8.10303ZM79.6128 8.10303H81.1069V20.2969H79.6128V8.10303Z" fill="#081F5F" />
                    </svg>

                    {sortingIcon}
                    {pdfAttachments(() => this.toggleFilterIcon(documentExtensions), this.state.extensionFilter === documentExtensions)}
                    {imageAttachments(() => this.toggleFilterIcon(imageExtensions), this.state.extensionFilter === imageExtensions)}
                    {videoAttachments(() => this.toggleFilterIcon(videoExtensions), this.state.extensionFilter === videoExtensions)}
                    {audioAttachments(() => this.toggleFilterIcon(audioExtensions), this.state.extensionFilter === audioExtensions)}
                    {modelAttachments(() => this.toggleFilterIcon(modelExtensions), this.state.extensionFilter === modelExtensions)}
                </div>
            </Fragment>
    }

    renderCurrentAttachments = (currentAttachments) => {
        return <ul id="current-attachments-list">
            {currentAttachments.length > 0 ?
                this.generateCurrentAttachmentList(currentAttachments)
                :
                <li key={"no items found"} className="flex-centered" id="attachment-item">
                    <p id="attachment-filename">No files currently attached</p>
                </li>}
        </ul>
    }

    renderRemainingAttachments = (previewingAttachment, remainingAttachments) => {
            if (previewingAttachment) return <div id={this.props.isAll ? "attachment-library-page" : "attachment-library"} className="flex" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                <FilePreview file={this.state.previewingAttachment} />
            </div>
            if (this.state.pickingColorTexture) return <div id={this.props.isAll ? "attachment-library-page" : "attachment-library"} className="flex" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                <FilePreview 
                    file={this.state.pickingColorTexture} 
                    isColorTexturePicker={true} 
                    selectedTextureIndex={this.state.selectedTextureIndex}
                    textures={this.textures}
                    onTextureSelect={this.handleTextureSelect}
                    clearTextureSelection={this.clearTextureSelection}
                    onTexturesSaved={this.handleTexturesSaved}
                />
            </div>
        return remainingAttachments.length > 0 ?
            <div id={this.props.isAll ? "attachment-library-page" : "attachment-library"} style={{ 
                maxHeight: window.innerWidth < 768 ? 'calc(20vh - 70px)' : 'calc(75vh - 60px)',
                overflowY: 'auto',
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
                gap: '10px',
                padding: '10px',
                marginBottom: '5px'
            }}>
                {remainingAttachments.map((attachment, index) => {
                    const isSelected = this.state.selectedLibraryItem && this.state.selectedLibraryItem._id === attachment._id
                    return <li key={attachment._id || `attachment-${index}`}
                              className={`flex-centered clickable ${isSelected ? 'selected' : ""}`} 
                              id="remaining-attachment-item"
                              onClick={(e) => this.selectLibraryItem(e, attachment)}
                              onContextMenu={(e) => this.showContextMenu(e, attachment)}
                              style={{
                                  width: '80%',
                                  minWidth: '120px',
                                  maxWidth: '400px',
                                  margin: '0 auto'
                              }}>
                        {renderTypeIcon(attachment.file_extension || attachment.fileExtension)}
                        <p className="ellipsis" id="attachment-filename">{attachment.path}</p>
                    </li>
                })}
            </div>
        :
            <div id={this.props.isAll ? "attachment-library-page" : "attachment-library"} className="flex" style={{ maxHeight: '40vh' }}>
                <li key={"no attachments items in Library"} className="flex-centered" id="attachment-item">
                    <p id="attachment-filename">No Items Found</p>
                </li>
            </div>
    }

    renderNewLayout = () => {
        let currentAttachments = this.state.currentAttachments;
        let remainingAttachments = this.state.remainingAttachments;
        
        // Apply filters from props (passed from Modal) OR from local state (when standalone)
        const searchText = this.props.searchText !== undefined ? this.props.searchText : this.state.searchText;
        const extensionFilter = this.props.extensionFilter !== undefined ? this.props.extensionFilter : this.state.extensionFilter;
        const sortOrder = this.props.sortOrder !== undefined ? this.props.sortOrder : this.state.sortOrder;
        const showOnlyAttached = this.props.showOnlyAttached !== undefined ? this.props.showOnlyAttached : false;
        
        if (searchText && searchText.length > 0) {
            currentAttachments = currentAttachments.filter(attachment => 
                attachment.path.toLowerCase().includes(searchText.toLowerCase())
            );
            remainingAttachments = remainingAttachments.filter(attachment => 
                attachment.path.toLowerCase().includes(searchText.toLowerCase())
            );
        }
        
        if (extensionFilter === 'AtoZ') {
            if (sortOrder === 'ascending') {
                remainingAttachments = SORT(2, remainingAttachments || [], "path");
                currentAttachments = SORT(2, currentAttachments || [], 'path');
            } else {
                remainingAttachments = SORT(1, remainingAttachments || [], "path");
                currentAttachments = SORT(1, currentAttachments || [], "path");
            }
        } else if (!!extensionFilter) {
            remainingAttachments = remainingAttachments.filter(attachment => 
                extensionFilter.includes(attachment.file_extension || attachment.fileExtension)
            );
            currentAttachments = currentAttachments.filter(attachment =>
                extensionFilter.includes(attachment.file_extension || attachment.fileExtension)
            );
        }
        
        // If showing only attached files, clear remainingAttachments
        if (showOnlyAttached) {
            remainingAttachments = [];
        }
        
        // Combine all attachments for display
        const allAttachments = [...currentAttachments, ...remainingAttachments];
        
        // If picking color/texture, show full-width preview
        if (this.state.pickingColorTexture) {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    height: '100%',
                    gap: '16px'
                }}>
                    {/* Full Width Color/Texture Picker */}
                    <div style={{
                        width: '100%',
                        height: this.props.isAll ? '100%' : '500px',
                        flex: this.props.isAll ? 1 : 'none',
                        minHeight: this.props.isAll ? 0 : 'auto',
                        // background: '#D9D9D9',
                        border: '3px solid #808080',
                        borderRadius: '4px',
                        overflow: 'hidden',
                        position: 'relative',
                        display: 'flex',
                        flexDirection: 'row',
                        flexShrink: this.props.isAll ? 1 : 0
                    }}>
                        {/* Model Preview - takes up most space */}
                        <div style={{ flex: 3, overflow: 'hidden' }}>
                            <FilePreview 
                                key={`${this.state.pickingColorTexture?._id}-picker`}
                                file={this.state.pickingColorTexture}
                                isColorTexturePicker={true}
                                selectedTextureIndex={this.state.selectedTextureIndex}
                                textures={this.textures}
                                onTextureSelect={this.handleTextureSelect}
                                clearTextureSelection={this.clearTextureSelection}
                                onTexturesSaved={this.handleTexturesSaved}
                            />
                        </div>
                        {/* Texture Selector - on the right */}
                        <div style={{ flex: 1, borderLeft: '2px solid #808080', overflow: 'auto' }}>
                            {this.renderTextureSelector()}
                        </div>
                    </div>
                    
                    {/* Bottom Buttons */}
                    <div style={{
                        display: 'flex',
                        gap: '12px',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        width: '100%',
                        flexShrink: 0,
                        paddingTop: '8px'
                    }}>
                        <button
                            onClick={() => this.setState({ 
                                pickingColorTexture: null, 
                                selectedTextureIndex: null,
                                texturesSaved: !this.state.texturesSaved // Toggle to force preview refresh
                            })}
                            style={{
                                width: '200px',
                                height: '39px',
                                background: '#081F5F',
                                borderRadius: '5px',
                                border: 'none',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '8px'
                            }}
                        >
                            <span style={{
                                color: '#FFF',
                                textAlign: 'center',
                                fontFamily: 'Inter',
                                fontSize: '16px',
                                fontStyle: 'normal',
                                fontWeight: '400',
                                lineHeight: 'normal'
                            }}>Back</span>
                        </button>
                    </div>
                </div>
            );
        }
        
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                height: this.props.isAll ? '100%' : 'auto',
                gap: '16px'
            }}>
                {/* Add header and filters for standalone mode (isAll=true) */}
                {this.props.isAll && (
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '12px',
                        marginBottom: '12px',
                        flexShrink: 0
                    }}>
                        {/* Title Row */}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <h2 style={{
                                textAlign: 'center',
                                color: '#081F5F',
                                fontSize: '20px',
                                fontFamily: 'Inter',
                                fontWeight: '600',
                                margin: 0
                            }}>
                                Attachments Library
                            </h2>
                        </div>
                        
                        {/* Search and Filters Row */}
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: '1fr auto 1fr',
                            alignItems: 'start',
                            gap: '16px',
                            minHeight: '42px',
                            width: '100%'
                        }}>
                            {/* Left spacer */}
                            <div />
                            
                            {/* Center the search bar */}
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center'
                            }}>
                                <SearchFilter 
                                    style={{ 
                                        border: "1px solid #808080",
                                        borderRadius: '5px',
                                        background: '#CDCDCD',
                                        width: "320px",
                                        height: '42px',
                                        padding: '0 10px',
                                        boxSizing: 'border-box'
                                    }} 
                                    filterList={(text) => this.filterLists(text)} 
                                    placeholder="Search By File Name..." 
                                />
                            </div>
                            
                            {/* Filters on the right */}
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-end',
                                gap: '6px',
                                flexWrap: 'wrap'
                            }}>
                                <button
                                    onClick={() => {
                                        this.setState({ 
                                            extensionFilter: null,
                                            sortOrder: 'grayed'
                                        });
                                    }}
                                    style={{
                                        width: '85px',
                                        height: '28px',
                                        borderRadius: '4px',
                                        border: '1px solid #081F5F',
                                        background: 'white',
                                        color: '#081F5F',
                                        fontSize: '14px',
                                        fontFamily: 'Inter',
                                        fontWeight: '400',
                                        cursor: 'pointer',
                                        flexShrink: 0
                                    }}
                                >
                                    Show All
                                </button>
                                {this.getSortingIcon()}
                                {pdfAttachments(() => this.toggleFilterIcon(documentExtensions), this.state.extensionFilter === documentExtensions)}
                                {imageAttachments(() => this.toggleFilterIcon(imageExtensions), this.state.extensionFilter === imageExtensions)}
                                {videoAttachments(() => this.toggleFilterIcon(videoExtensions), this.state.extensionFilter === videoExtensions)}
                                {audioAttachments(() => this.toggleFilterIcon(audioExtensions), this.state.extensionFilter === audioExtensions)}
                                {modelAttachments(() => this.toggleFilterIcon(modelExtensions), this.state.extensionFilter === modelExtensions)}
                            </div>
                        </div>
                    </div>
                )}
                
                {/* Top Row - Both Panes */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    flex: this.props.isAll ? 1 : 'none',
                    minHeight: this.props.isAll ? 0 : 'auto',
                    gap: '16px'
                }}>
                    {/* Left Pane - Preview */}
                    <div style={{
                        flex: '1',
                        minWidth: 0,
                        height: this.props.isAll ? '100%' : '500px',
                        background: '#D9D9D9',
                        border: '3px solid #808080',
                        borderRadius: '4px',
                        overflow: 'hidden',
                        position: 'relative',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: this.props.isAll ? 1 : 0
                    }}>
                        {this.state.selectedLibraryItem || this.state.selectedCurrentAttachment ? (
                            <FilePreview 
                                key={`${(this.state.selectedLibraryItem || this.state.selectedCurrentAttachment)?._id}-preview-${this.state.texturesSaved ? 'saved' : 'nosave'}`}
                                file={this.state.selectedLibraryItem || this.state.selectedCurrentAttachment}
                                isColorTexturePicker={false}
                                selectedTextureIndex={this.state.selectedTextureIndex}
                                textures={this.textures}
                                onTextureSelect={this.handleTextureSelect}
                                clearTextureSelection={this.clearTextureSelection}
                                onTexturesSaved={this.handleTexturesSaved}
                            />
                        ) : (
                            <div style={{
                                textAlign: 'center',
                                color: '#081F5F',
                                fontSize: '18px',
                                fontFamily: 'Inter'
                            }}>
                                Set a default attachment to view in this window
                            </div>
                        )}
                    </div>
                    
                    {/* Right Pane - Attachment List */}
                    <div style={{
                        flex: '1',
                        minWidth: 0,
                        height: this.props.isAll ? '100%' : '500px',
                        border: '3px solid #808080',
                        borderRadius: '4px',
                        overflow: 'hidden',
                        display: 'flex',
                        flexDirection: 'column',
                        flexShrink: this.props.isAll ? 1 : 0
                    }}>
                        {/* Attachment Grid */}
                        <div style={{
                            flex: 1,
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            padding: '10px',
                            display: 'grid',
                            gridTemplateColumns: 'repeat(2, 1fr)',
                            gap: '10px',
                            alignContent: 'start'
                        }}>
                            {allAttachments.map((attachment) => {
                                const isAttached = currentAttachments.some(att => att._id === attachment._id);
                                const isSelected = (this.state.selectedLibraryItem && this.state.selectedLibraryItem._id === attachment._id) ||
                                                 (this.state.selectedCurrentAttachment && this.state.selectedCurrentAttachment._id === attachment._id);
                                
                                return (
                                    <div
                                        key={attachment._id}
                                        onClick={() => this.handleAttachmentClick(attachment, isAttached)}
                                        onContextMenu={(e) => this.showContextMenu(e, attachment)}
                                        style={{
                                            height: '64px',
                                            background: isSelected ? '#A2B3DE' : 'white',
                                            borderRadius: '10px',
                                            outline: '3px #BFC0C0 solid',
                                            outlineOffset: '-3px',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '0 12px',
                                            gap: '10px',
                                            overflow: 'hidden',
                                            transition: 'background 0.2s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            if (!isSelected) e.currentTarget.style.background = '#f0f0f0';
                                        }}
                                        onMouseLeave={(e) => {
                                            if (!isSelected) e.currentTarget.style.background = 'white';
                                        }}
                                    >
                                        {renderTypeIcon(attachment.file_extension || attachment.fileExtension)}
                                        <div style={{
                                            flex: 1,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            color: '#081F5F',
                                            fontSize: '18px',
                                            fontFamily: 'Inter',
                                            fontWeight: '400'
                                        }}>
                                            {attachment.path}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
                
                {/* Bottom Row - Action Buttons */}
                <div style={{
                    display: 'flex',
                    gap: '12px',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    width: '100%',
                    flexShrink: 0,
                    paddingTop: '8px'
                }}>
                    {/* Show Pick Color/Texture button for model files (always visible) */}
                    {(this.state.selectedLibraryItem || this.state.selectedCurrentAttachment) && (() => {
                        const selectedFile = this.state.selectedLibraryItem || this.state.selectedCurrentAttachment;
                        const fileExtension = selectedFile?.file_extension || selectedFile?.fileExtension || '';
                        const isModelFile = modelExtensions.includes(fileExtension);
                        
                        if (isModelFile) {
                            return (
                                <div onClick={this.pickColorTexture} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                    {PickColorTextureIcon()}
                                </div>
                            );
                        }
                        return null;
                    })()}
                    
                    {/* Only show Attach/Detach buttons when NOT in standalone mode (isAll) */}
                    {!this.props.isAll && (this.state.selectedLibraryItem || this.state.selectedCurrentAttachment) && (
                        <button
                            onClick={this.toggleAttachment}
                            style={{
                                width: '200px',
                                height: '39px',
                                background: '#081F5F',
                                borderRadius: '5px',
                                border: 'none',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '8px'
                            }}
                        >
                            <span style={{
                                color: '#FFF',
                                textAlign: 'center',
                                fontFamily: 'Inter',
                                fontSize: '16px',
                                fontStyle: 'normal',
                                fontWeight: '400',
                                lineHeight: 'normal'
                            }}>
                                {currentAttachments.some(att => att._id === (this.state.selectedCurrentAttachment?._id || this.state.selectedLibraryItem?._id)) 
                                    ? 'Detach File' : 'Attach File'}
                            </span>
                            <img src={attachFileIconPng} alt="" style={{ width: '20px', height: '20px' }} />
                        </button>
                    )}
                    <button
                        onClick={this.uploadFile}
                        style={{
                            width: '200px',
                            height: '39px',
                            background: '#081F5F',
                            borderRadius: '5px',
                            border: 'none',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px'
                        }}
                    >
                        <span style={{
                            color: '#FFF',
                            textAlign: 'center',
                            fontFamily: 'Inter',
                            fontSize: '16px',
                            fontStyle: 'normal',
                            fontWeight: '400',
                            lineHeight: 'normal'
                        }}>Upload a File</span>
                        <img src={uploadFileIcon} alt="" style={{ width: '20px', height: '20px' }} />
                    </button>
                </div>
            </div>
        );
    }

    handleAttachmentClick = (attachment, isAttached) => {
        // Set as preview
        if (isAttached) {
            this.setState({ 
                selectedCurrentAttachment: attachment,
                selectedLibraryItem: null
            });
        } else {
            this.setState({ 
                selectedLibraryItem: attachment,
                selectedCurrentAttachment: null
            });
        }
    }

    render = () => {
     
            let currentAttachments = this.state.currentAttachments
            let remainingAttachments = this.state.remainingAttachments
            if (this.state.filteringAttachments) {
                let searchText = this.state.searchText
                currentAttachments = currentAttachments.filter(attachment => attachment.path.toLowerCase().includes(searchText.toLowerCase()))
                remainingAttachments = remainingAttachments.filter(attachment => attachment.path.toLowerCase().includes(searchText.toLowerCase()))
            }
       
        if(this.state.extensionFilter === 'AtoZ'){
            //WILL RETURN A SORTED LIST OF ATTACHMENTS
            if (this.state.sortOrder === 'ascending') {
                remainingAttachments = SORT(2, remainingAttachments || [], "path")
                currentAttachments = SORT(2, currentAttachments || [], 'path')
              } else {
                remainingAttachments = SORT(1, remainingAttachments || [], "path")
                currentAttachments = SORT(1, currentAttachments || [], "path")
            }
        }
        else if (!!this.state.extensionFilter) {
            remainingAttachments = remainingAttachments.filter(attachment => { 
                return this.state.extensionFilter.includes(attachment.file_extension || attachment.fileExtension)
            })
            currentAttachments = currentAttachments.filter(attachment => {
               return this.state.extensionFilter.includes(attachment.file_extension || attachment.fileExtension)
            })
        }
        
        // Wrap content in a modal-like container when used as standalone page (isAll=true)
        const content = this.state.isLoading ? 
                    this.renderLoadingAnimation()
                :
                <Fragment>
                    {/* Context Menu */}
                    {this.state.contextMenu.show && (
                        <div
                            style={{
                                position: 'fixed',
                                top: this.state.contextMenu.y,
                                left: this.state.contextMenu.x,
                                backgroundColor: 'white',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                                zIndex: 1000,
                                minWidth: '120px'
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div
                                style={{
                                    padding: '8px 16px',
                                    cursor: 'pointer',
                                    color: '#d32f2f',
                                    fontSize: '14px',
                                    borderBottom: 'none'
                                }}
                                onClick={this.deleteAttachment}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                            >
                                Delete
                            </div>
                        </div>
                    )}
                    
                    {/* Hidden file input for upload */}
                    <div style={{ display: "none" }}>
                        <input type="file" name="attachment" id="attachment" onChange={this.uploadMediaFile} />
                    </div>
                    
                    {/* New Simplified Layout */}
                    {this.renderNewLayout()}
                </Fragment>
        
        // If this is being used as a standalone page (isAll=true), wrap it in a modal-like container
        if (this.props.isAll) {
            return (
                <div style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    padding: '20px',
                    boxSizing: 'border-box',
                    overflow: 'hidden'
                }}>
                    <div style={{
                        width: '90%',
                        maxWidth: '1500px',
                        height: 'calc(100vh - 140px)',
                        backgroundColor: '#fff',
                        border: '3px solid #808080',
                        borderRadius: '4px',
                        padding: '24px 48px',
                        boxSizing: 'border-box',
                        overflow: 'hidden',
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        {content}
                    </div>
                </div>
            );
        }
        
        // Otherwise, return content directly (for use in modal)
        return content;
    }
}
